import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AboutUs = () => {
  const { language } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/content`).then(res => {
      const aboutContent = res.data.find(c => c.section_key === 'about');
      setContent(aboutContent);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const values = [
    { title_en: 'Compassionate Care', title_hi: 'सहानुभूतिपूर्ण देखभाल', desc_en: 'We treat every patient with empathy and respect', desc_hi: 'हम हर मरीज के साथ सहानुभूति और सम्मान के साथ व्यवहार करते हैं' },
    { title_en: 'Excellence', title_hi: 'उत्कृष्टता', desc_en: 'Committed to delivering the highest quality healthcare', desc_hi: 'उच्चतम गुणवत्ता वाली स्वास्थ्य सेवा प्रदान करने के लिए प्रतिबद्ध' },
    { title_en: 'Teamwork', title_hi: 'टीमवर्क', desc_en: 'Collaborative approach for better patient outcomes', desc_hi: 'बेहतर रोगी परिणामों के लिए सहयोगात्मक दृष्टिकोण' },
    { title_en: 'Availability', title_hi: 'उपलब्धता', desc_en: '24/7 emergency services for your peace of mind', desc_hi: 'आपकी मानसिक शांति के लिए 24/7 आपातकालीन सेवाएं' },
  ];

  return (
    <div className="min-h-screen bg-white font-body" data-testid="about-page">
      <Navbar />

      <PageHero
        kicker={language === 'en' ? 'Our story' : 'हमारी कहानी'}
        title={language === 'en' ? 'About Us' : 'हमारे बारे में'}
        testId="about-hero"
      />

      {loading ? (
        <div className="py-20 text-center text-neutral-400">Loading...</div>
      ) : (
        <>
          {content && (
            <div className="py-20 md:py-28">
              <div className="max-w-3xl mx-auto px-6 text-center">
                <h2 className="font-heading font-light text-2xl sm:text-3xl text-brand-navy uppercase tracking-wide mb-4">
                  {language === 'en' ? content.title_en : content.title_hi}
                </h2>
                <div className="w-10 h-px bg-brand-teal mx-auto mb-8"></div>
                <p className="text-neutral-600 font-body font-light text-base leading-relaxed">
                  {language === 'en' ? content.content_en : content.content_hi}
                </p>
              </div>
            </div>
          )}

          {/* Values — Dark section */}
          <div className="bg-brand-navy py-24 md:py-32">
            <div className="max-w-5xl mx-auto px-6">
              <div className="text-center mb-14">
                <p className="text-xs uppercase tracking-ultra-wide text-brand-teal-light font-body mb-3">
                  {language === 'en' ? 'What we stand for' : 'हम किसके लिए खड़े हैं'}
                </p>
                <h2 className="font-heading font-light text-3xl text-white uppercase tracking-ultra-wide mb-4">
                  {language === 'en' ? 'Our Values' : 'हमारे मूल्य'}
                </h2>
                <div className="w-12 h-px bg-brand-teal-light mx-auto"></div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-testid="values-grid">
                {values.map((value, index) => (
                  <div key={index} className="text-center" data-testid={`value-card-${index}`}>
                    <h3 className="font-heading font-light text-xl text-white uppercase tracking-wide mb-4">
                      {language === 'en' ? value.title_en : value.title_hi}
                    </h3>
                    <div className="w-8 h-px bg-brand-teal-light mx-auto mb-4"></div>
                    <p className="text-white/70 font-body font-light text-sm leading-relaxed">
                      {language === 'en' ? value.desc_en : value.desc_hi}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}

      <Footer />
    </div>
  );
};

export default AboutUs;
